import { Link, useLocation } from 'react-router-dom';
import { getLocaleFromPath, localizePath } from '@/utils/locale';

/** 根据当前路由语言自动为 Link 的 to 添加或去除 /en 前缀 */
const LocalizedLink = ({ to, ...rest }) => {
  const location = useLocation();
  const locale = getLocaleFromPath(location.pathname);
  const resolvedTo = typeof to === 'string' ? localizePath(to, locale) : to;

  return <Link to={resolvedTo} {...rest} />;
};

export default LocalizedLink;
